<div class="home__services__container">
  <div class="service__item">
    <div class="service__icon">
      <img
        width="40"
        src="assets/img/delivery-truck.svg"
        [alt]="'home.services.shipping.title' | translate"
      />
    </div>
    <div class="service__text">
      <div class="service__title">{{ 'home.services.shipping.title' | translate }}</div>
      <div class="service__description">{{ 'home.services.shipping.desc' | translate }}</div>
    </div>
  </div>

  <div class="service__item">
    <div class="service__icon">
      <img 
        width="40" 
        src="assets/img/headphones.svg" 
        [alt]="'home.services.support.title' | translate" 
      />
    </div>
    <div class="service__text">
      <div class="service__title">{{ 'home.services.support.title' | translate }}</div>
      <div class="service__description">{{ 'home.services.support.desc' | translate }}</div>
    </div>
  </div>

  <div class="service__item">
    <div class="service__icon">
      <img 
        width="40" 
        src="assets/img/shopping-bag.svg" 
        [alt]="'home.services.payment.title' | translate" 
      />
    </div>
    <div class="service__text">
      <div class="service__title">{{ 'home.services.payment.title' | translate }}</div>
      <div class="service__description">{{ 'home.services.payment.desc' | translate }}</div>
    </div>
  </div>

  <div class="service__item">
    <div class="service__icon">
      <img 
        width="40" 
        src="assets/img/package.svg" 
        [alt]="'home.services.refund.title' | translate" 
      />
    </div>
    <div class="service__text">
      <div class="service__title">{{ 'home.services.refund.title' | translate }}</div>
      <div class="service__description">{{ 'home.services.refund.desc' | translate }}</div>
    </div>
  </div>
</div>